

export default class GiftList{
    constructor(){
        this._giftList = [];
        this._selected = [];
        this._parent = null;
        this.goodsDetailUrl = null
    }

    setParent(parent){
        this._parent = parent;
    }
    
    init(data){
        // if(data.length >0 ){
            this._giftList = data.giftsSelectable;
            this.goodsDetailUrl = data.goodsDetailUrl
        // }
    }    
}